export default __webpack_public_path__ + "static/media/aboutwavetop.ccb4a0b0.png";